import React, { Fragment, useState, useEffect } from 'react';
import { Row, Col, Container, Card, Button } from 'react-bootstrap';
import { Navigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCirclePlus, faAlignJustify } from '@fortawesome/free-solid-svg-icons'
import '../../../styles/diario.scss';


function HomeLoggedDocsSaudeScreen() {
    const [cad, setCad] = useState(false)
    const [listar, setListar] = useState(false)
    const [adm, setAdm] = useState(false)
    const [control, setControl] = useState(false)
    const nivel = localStorage.getItem('nivel');
    const nome = localStorage.getItem('nome');
    const verNivel = (nivel) => {
        if (nivel === "Administrador") {
            setAdm(true)
        } else if (nivel === "Controle Interno") {
            setControl(true)
        }
    }
    
    useEffect(() => {
        verNivel(nivel)
    }, [nivel])

    if(listar) {
        return <Navigate to={{pathname: '/restrito/contas/listar'}}/>
    }

    if(cad) {
        return <Navigate to={{pathname: '/restrito/contas/cadastrar'}}/>
    }

    return (
        <Fragment>
            <Container>
                <h5>Bem vindo, {nome}, o que deseja fazer?</h5><br/>
                <Row xs={1} lg={2}>
                    <Col>
                        <Card className='card-list' onClick={e => setCad(true)}>
                            <Card.Body>
                                <Row xs={1}>
                                    <Col>
                                        <Row xs={2}>
                                            <Col xs={3}>
                                                <FontAwesomeIcon className='icon-cad' icon={faFileCirclePlus} />
                                            </Col>
                                            <Col xs={9}>
                                                <p className='titulo-lei'>Cadastrar Documento</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card className='card-list' onClick={e => setListar(true)}>
                            <Card.Body>
                                <Row xs={1}>
                                    <Col>
                                        <Row xs={2}>
                                            <Col xs={3}>
                                                <FontAwesomeIcon className='icon-cad' icon={faAlignJustify} />
                                            </Col>
                                            <Col xs={9}>
                                                <p className='titulo-lei'>Listar Documentos</p>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                {adm ?
                    <Fragment>
                        <br /><br />
                        <Link to={'/restrito'}>
                            <Button variant="danger" type="button">
                                Voltar
                            </Button>
                        </Link>
                    </Fragment> : ''}
                    {control ?
                    <Fragment>
                        <br /><br />
                        <Link to={'/restrito/controle'}>
                            <Button variant="danger" type="button">
                                Voltar
                            </Button>
                        </Link>
                    </Fragment> : ''}
            </Container>
        </Fragment>
    );
}

export default HomeLoggedDocsSaudeScreen;